<template>
  <div
    class="spinner-host"
    :class="{
      'spinner-host--preview': preview,
      'spinner-host--dragster-neon': selectedSpinner === 'dragster-neon'
    }"
  >
    <svg v-if="selectedSpinner === 'circle' || (!activeDragster && !spinnerComponent)" v-bind:style="styles" class="spinner spinner--circle" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
    </svg>
    <img v-else-if="activeDragster" :style="dragsterStyles" class="dragster" alt="Animation de chargement Dragster" src="../../assets/img/dragster.gif"/>
    <component
      v-else
      :is="spinnerComponent"
      :key="selectedSpinner"
      :size="componentSize"
      :preview="preview"
    />
  </div>
</template>

<script>
import Circle8 from './Circle8'
import Circle10 from './Circle10'
import CubeGrid from './CubeGrid'
import DragsterNeon from './DragsterNeon'
import Jumper from './Jumper'
import LetterCube from './LetterCube'
import MikePad from './MikePad'
import Plane from './Plane'
import Strech from './Strech'
import ThreeDots from './ThreeDots'
import { normalizeSpinner } from './spinnerOptions'

const SPINNER_COMPONENTS = Object.freeze({
  'circle-8': Circle8,
  'circle-10': Circle10,
  'cube-grid': CubeGrid,
  'dragster-neon': DragsterNeon,
  'jumper': Jumper,
  'letter-cube': LetterCube,
  'mike-pad': MikePad,
  'plane': Plane,
  'stretch': Strech,
  'three-dots': ThreeDots
})

export default {
  props: {
    size: {
      default: '40px'
    },
    variant: {
      type: String,
      default: null
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    styles () {
      return {
        width: this.size,
        height: this.size
      }
    },
    dragsterStyles () {
      var size = this.preview ? 84 : Math.max(parseInt(this.size) * 4, 140)

      return {
        width: size + 'px',
        height: size + 'px'
      }
    },
    selectedSpinner(){
      var profile = this.$store && this.$store.getters
        ? this.$store.getters['profile/me']
        : null
      var globalSpinner = typeof window !== 'undefined' && window.App
        ? window.App.spinner
        : null

      return normalizeSpinner(this.variant || (profile && profile.spinner) || globalSpinner)
    },
    spinnerComponent(){
      return SPINNER_COMPONENTS[this.selectedSpinner] || null
    },
    componentSize(){
      if(this.selectedSpinner !== 'dragster-neon') return this.size

      return (this.preview ? 64 : Math.max(parseInt(this.size) * 2, 72)) + 'px'
    },
    activeDragster(){
      return this.selectedSpinner === 'dragster'
    }
  },
}
</script>
<style lang="scss" scoped>
.spinner-host {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 20%;
  min-height: 40px;
  position: relative;
  text-align: center;
  width: 100%;
}

.spinner-host--preview {
  margin-top: 0;
  min-height: 84px;
}

.dragster {
  object-fit: contain;
}

$offset: 187;
$duration: 1.4s;
.spinner {
  * {
    line-height: 0;
    box-sizing: border-box;
  }
}
.spinner--circle {
  animation: circle-rotator $duration linear infinite;
}
@keyframes circle-rotator {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(270deg); }
}
.path {
  stroke-dasharray: $offset;
  stroke-dashoffset: 0;
  transform-origin: center;
  animation:
      circle-dash $duration ease-in-out infinite,
      circle-colors ($duration*4) ease-in-out infinite;
}
@keyframes circle-colors {
  0% {
    stroke: #35495e;
  }
  25% {
    stroke: #DE3E35;
  }
  50% {
    stroke: #F7C223;
  }
  75% {
    stroke: #0089ff;
  }
  100% {
    stroke: #35495e;
  }
}
@keyframes circle-dash {
  0% {
    stroke-dashoffset: $offset;
  }
  50% {
    stroke-dashoffset: $offset/4;
    transform:rotate(135deg);
  }
  100% {
    stroke-dashoffset: $offset;
    transform:rotate(450deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .spinner-host:not(.spinner-host--dragster-neon) * {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
  }
}
</style>
